import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'
import PropTypes from 'prop-types'

import FloatingContactButton from './FloatingContactButton'
import SlideOutContactForm from './SlideOutContactForm'

const ContactFormContext = createContext({
  openContactForm: () => {},
  closeContactForm: () => {},
  toggleContactForm: () => {},
  isContactFormOpen: false,
})

export const useContactForm = () => useContext(ContactFormContext)

const GlobalContactForm = ({ children = null }) => {
  const [isOpen, setIsOpen] = useState(false)

  const openContactForm = useCallback(() => setIsOpen(true), [])
  const closeContactForm = useCallback(() => setIsOpen(false), [])
  const toggleContactForm = useCallback(
    () => setIsOpen((prev) => !prev),
    []
  )

  const contextValue = useMemo(
    () => ({
      openContactForm,
      closeContactForm,
      toggleContactForm,
      isContactFormOpen: isOpen,
    }),
    [openContactForm, closeContactForm, toggleContactForm, isOpen]
  )

  return (
    <ContactFormContext.Provider value={contextValue}>
      {children}
      <FloatingContactButton onClick={toggleContactForm} open={isOpen} />
      <SlideOutContactForm open={isOpen} onClose={closeContactForm} />
    </ContactFormContext.Provider>
  )
}

GlobalContactForm.propTypes = {
  children: PropTypes.node,
}

export default GlobalContactForm
